import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import {
    IS_B2B_BIZ_USER,
    IS_CORP_USER,
    IS_DOCUMENTS_DOMAIN,
    IS_ONPREMISE,
    IS_PAID_USER,
    IS_PHONE_BROWSER,
} from 'reactApp/appHelpers/configHelpers';

type TariffList = {
    year: string[];
    month: string[];
};

// CLOUDWEB-19645 ИИ-тариф: лендинг - карточки тарифов
// PDSM-5675 ИИ-тариф
const aiTariffAb: false | 'b' | 'c1' | 'c2' | 'd' = !IS_PHONE_BROWSER && !IS_B2B_BIZ_USER && !IS_ONPREMISE && getFeature('ai-tariff-ab');

export const aiTariffAbVariantB = aiTariffAb === 'b';
export const aiTariffAbVariantC1 = aiTariffAb === 'c1';
export const aiTariffAbVariantC2 = aiTariffAb === 'c2';
export const aiTariffAbVariantD = aiTariffAb === 'd';

export const aiTariffAbEnabled = aiTariffAbVariantB || aiTariffAbVariantC1 || aiTariffAbVariantC2 || aiTariffAbVariantD;

export const aiTariffByOptionsSwitcherStateOff = isFeature('ai-tariff-by-options-switcher-state-off');

export const aiTariffIdVarB: TariffList = getFeature('ai-tariff-id') || {
    month: ['W256GB_1m_ai_features_main'],
    year: ['W256GB_1y_ai_features_main'],
};

export const aiTariffsVariantBTariffList: TariffList = getFeature('ai-tariff-list') || {
    year: [
        'W256GB_1y_landing_segmentation_pretty_address_discount',
        'W512GB_1y_landing_segmentation_pretty_address_discount',
        'W1TB_1y_landing_segmentation_pretty_address_discount',
        'W2TB_1y_landing_segmentation_pretty_address_discount',
    ],
    month: [
        'W256GB_1m_landing_segmentation_discount',
        'W512GB_1m_landing_segmentation_discount',
        'W1TB_1m_landing_segmentation_discount',
        'W2TB_1m_landing_segmentation_discount',
        'W4TB_1m_landing_segmentation_discount',
    ],
};

export const aiTariffByOptionsTariffs: TariffList =
    getFeature('ai-tariff-by-option-list') ||
    (aiTariffAbVariantC1
        ? {
              year: ['W256GB_1y_ai_features', 'W512GB_1y_ai_features', 'W1TB_1y_ai_features', 'W2TB_1y_ai_features'],
              month: ['W256GB_1m_ai_features', 'W512GB_1m_ai_features', 'W1TB_1m_ai_features', 'W2TB_1m_ai_features'],
          }
        : {
              year: [
                  'W256GB_1y_ai_features_price_v2',
                  'W512GB_1y_ai_features_price_v2',
                  'W1TB_1y_ai_features_price_v2',
                  'W2TB_1y_ai_features_price_v2',
              ],
              month: [
                  'W256GB_1m_ai_features_price_v2',
                  'W512GB_1m_ai_features_price_v2',
                  'W1TB_1m_ai_features_price_v2',
                  'W2TB_1m_ai_features_price_v2',
              ],
          });

export const aiTariffVariantDTariffs: TariffList = getFeature('ai-tariff-variant-d-list') || {
    year: [
        'W256GB_1y_ai_features_price_v3',
        'W512GB_1y_ai_features_price_v3',
        'W1TB_1y_ai_features_price_v3',
        'W2TB_1y_ai_features_price_v3',
    ],
    month: [
        'W256GB_1m_ai_features_price_v3',
        'W512GB_1m_ai_features_price_v3',
        'W1TB_1m_ai_features_price_v3',
        'W2TB_1m_ai_features_price_v3',
    ],
};

export const aiTariffIdsListCommon: string[] = aiTariffAbVariantB ? [...aiTariffIdVarB.month, ...aiTariffIdVarB.year] : [];

export const paySourceAiTariff = 'try_neiro_tariff';

// CLOUDWEB-19670
// Промо-модалка нового ИИ-тарифа при открытии лендоса

/** id промо - для включения нужно будет включать фичу 3promo-enable-{id} */
export const PROMO_ID = 'ai-tariff-popup';
/** Ключ для локалстораджа от баннера */
export const storageKeyForBanner = `3promo:${PROMO_ID}`;
export const isFeatureEnableAiTariffPopupPromo = isFeature(`3promo-enable-${PROMO_ID}`);

/** Временной промежуток между показами одной и той же промки, в секундах */
export const showInterval: number = +getFeature(`${PROMO_ID}-show-interval`) || 604800;
/** Максимальное количество закрытий промки (на крестик в баннере / на primary кнопку) */
export const closeLimit: number = +getFeature(`${PROMO_ID}-close-limit`) || 3;
/** Максимальное количество показов, в которых не взаимодействуют с промкой */
export const showLimit: number = +getFeature(`${PROMO_ID}-show-limit`) || 3;

// CLOUDWEB-19669
// ИИ-тариф: промо-объект внизу страницы + периодический показ
export const isNeuroTariffPromoObject =
    !IS_PHONE_BROWSER &&
    !IS_PAID_USER &&
    !IS_B2B_BIZ_USER &&
    !IS_CORP_USER &&
    !IS_DOCUMENTS_DOMAIN &&
    isFeature('neuro-tariff-promo-object-enable');
